import { render, staticRenderFns } from "./edit-order.vue?vue&type=template&id=154e559e&scoped=true&"
import script from "./edit-order.vue?vue&type=script&lang=ts&"
export * from "./edit-order.vue?vue&type=script&lang=ts&"
import style0 from "./edit-order.vue?vue&type=style&index=0&id=154e559e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e559e",
  null
  
)

component.options.__file = "edit-order.vue"
export default component.exports